export enum UrlType {
  PUBLIC_URL = 'public_url',
  YOUTUBE_LINK = 'youtube_link',
  VIMEO_LINK = 'vimeo_link',
}

export enum UploadMode {
  FILE = 'file',
  URL = 'url',
}

export interface ExpertContent {
  _id: string;
  title: string;
  description: string;
  fileType: string;
  fileName: string;
  fileCategory: string;
  contentUrl: string;
  thumbnail: string;
  createdAt: string;
  updatedAt: string;
  isExternalFile: boolean;
  thumbnailGenerated: string;
  path?: string;
  subFolders?: ExpertContent[];
  hasSubFolders?: boolean;
  urlType?: UrlType;
}

export interface SelectedFolderData {
  id: string;
  name: string;
  path: string;
}

export interface IUploadMediaModalForm {
  title: string;
  description: string;
  entId: string;
  expertId: string;
  contentUrl: string;
  fileType: string;
  fileName: string;
  fileCategory: string | null;
  isExternalFile: boolean;
  thumbnailGenerated: string;
  urlType?: UrlType;
}

export interface ExpertUploadMediaParam {
  title: string;
  description: string;
  entId: string;
  expertId: string;
  contentUrl: string;
  fileType: string;
  fileName: string;
  fileCategory: string;
  path: string;
  isExternalFile: boolean;
  thumbnailGenerated: string;
  urlType?: UrlType;
  resolve?: any;
  reject?: any;
}

export interface CreateFolderForm {
  name: string;
  path: string;
}

export interface FetchFolderSelectorMediaPayload {
  expertId: string;
  path: string;
  type: string;
}
